import Account from "./Account";
import Footer from "../components//Footer";
import React from "react";
import MetaComponent from "../components/MetaComponent";
import Header from "../components/Header";
import usePageReady from "../../shared/usePageReady";


const metadata = {
    title: `Account Page || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};
export default function AccountPage({ onPageReady }) {
    usePageReady(onPageReady);
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <Account />
            <Footer />
        </>
    );
}
